import AddResources from "../../../Components/Pricings/Resources/AddResources";



export default function CreateResource(){
    return(
        <div data-testid="add-resources-component">
        <AddResources/></div>
    )
}